import { UserExerciseSession } from '../workoutsession';
import { Exercise, ExerciseFormat } from './../exercise/exercise';

export class ExerciseSelection {
  public static fromUserExerciseSession(userExerciseSession: UserExerciseSession) {
    return new ExerciseSelection(
      userExerciseSession.zone.typeNumber,
      userExerciseSession.format,
      userExerciseSession.exercise,
      userExerciseSession.alternateExercise);
  }

  public static fromZoneTypeAndUserExerciseSession(zoneType: number, userExerciseSession: UserExerciseSession) {
    return new ExerciseSelection(
      zoneType,
      userExerciseSession.format,
      userExerciseSession.exercise,
      userExerciseSession.alternateExercise);
  }

  public static getExercisesInOrder(exerciseSelection: ExerciseSelection): Exercise[] {
    const exs = [exerciseSelection.exercise];
    if (exerciseSelection.alternateExercise) {
      exs.push(exerciseSelection.alternateExercise);
    }
    if (exerciseSelection.secondAlternateExercise) {
      exs.push(exerciseSelection.secondAlternateExercise);
    }
    if (exerciseSelection.thirdAlternateExercise) {
      exs.push(exerciseSelection.thirdAlternateExercise);
    }
    return exs;
  }

  public zone: number;
  public exercise: Exercise;
  public alternateExercise: Exercise | undefined;
  public secondAlternateExercise: Exercise | undefined;
  public thirdAlternateExercise: Exercise | undefined;
  public format: ExerciseFormat = ExerciseFormat.Burn2Endurance;
  public approved: boolean;
  public changed: Date;
  public changeHasNotBeenReviewed: boolean;

  constructor(
    zone: number,
    format: ExerciseFormat,
    exercise: Exercise,
    alternateExercise?: Exercise,
    secondAlternateExercise?: Exercise,
    thirdAlternateExercise?: Exercise,
    ) {
    this.zone = zone;
    this.format = format;
    this.exercise = exercise;
    this.alternateExercise = alternateExercise;
    this.secondAlternateExercise = secondAlternateExercise;
    this.thirdAlternateExercise = thirdAlternateExercise;
    this.approved = false;
    this.changeHasNotBeenReviewed = false;
  }

  public setSessionFormat(format: ExerciseFormat) {
    this.format = format;
  }

  public setSessionExercise(exercise: Exercise) {
    this.exercise = exercise;
  }

  public setAlternativeSessionExercise(alternateExercise: Exercise) {
    this.alternateExercise = alternateExercise;
  }
}
